/**
 * One sibling treatment cannot be sold; the rest of the basket still can.
 *
 * The runtime fails closed when a recommended Program has no patient-orderable
 * option -- unserviceable in the care state, or misconfigured. With a single
 * treatment that ended the journey. With more than one it must not, so the
 * error carries the blocked treatment's identity and the Programs that survive.
 */

const CONTINUE_WITHOUT = "continue_without_treatment";

/**
 * Return the continue-without action carried by a runtime error, or null.
 *
 * `program_ids` is the surviving set with the blocked Program already removed.
 * It must be passed back explicitly: the recommendations transition falls back
 * to the session's full recommended list when a caller sends nothing, which
 * would re-add the very treatment being dropped.
 */
export const blockedTreatmentAction = (error) => {
  const details = error?.details || error?.response?.data?.details || null;
  const action = details?.corrective_action || null;
  if (action?.code !== CONTINUE_WITHOUT) return null;
  const programIds = Array.isArray(action.program_ids)
    ? action.program_ids.map(String).filter(Boolean)
    : [];
  if (!programIds.length) return null;
  return {
    label: action.label || "Continue without this treatment",
    treatmentLabel: details.label || "",
    treatmentTypeId: String(details.treatment_type_id || ""),
    programId: String(details.program_id || ""),
    programIds,
  };
};

export const isBlockedTreatmentError = (error) =>
  blockedTreatmentAction(error) !== null;
